<div class="glossary-container">
  <ng-container *ngFor="let section of glossarySections; last as isLast">
    <common-glossary-section [glossarySection]="section"> </common-glossary-section>

    <div class="bb-light my-5" *ngIf="!isLast"></div>
  </ng-container>
</div>
